"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuestions = useQuestions;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
const rounds_1 = require("./rounds");
function useQuestions() {
    const questions = (0, stores_1.useCalculatorStore)((state) => state.data.questions);
    const candidates = (0, stores_1.useCalculatorStore)((state) => state.data.candidates);
    const candidatesAnswers = (0, stores_1.useCalculatorStore)((state) => state.data.candidatesAnswers);
    const round = (0, rounds_1.useRound)();
    return (0, react_1.useMemo)(() => (0, view_models_1.questionsViewModel)(round ? (0, view_models_1.visibleQuestions)({ questions, candidates, candidatesAnswers, currentRound: round.current }) : questions), [questions, candidates, candidatesAnswers, round]);
}
